var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GridChartCard',{ref:"chartCard",attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"hasData":_vm.hasData},on:{"download-csv":function($event){return _vm.data.generateCSV()},"draw":_vm.createChart}})
}
var staticRenderFns = []

export { render, staticRenderFns }